import 'dotenv/config';
import { z } from 'zod';
import chalk from 'chalk';
import path from 'node:path';
import { Command } from 'commander';
import { existsSync } from 'node:fs';

import { logger, runSetupProcess, getMultiverseUIConfig } from '../utils';

const initOptionsSchema = z.object({
  cwd: z.string(),
});

const init = new Command()
  .name('init')
  .description('initialize your project and install dependencies')
  .option(
    '-c, --cwd <cwd>',
    'the working directory. defaults to the current directory.',
    process.cwd()
  )
  .action(async (opts) => {
    try {
      const options = initOptionsSchema.parse(opts);
      const cwd = path.resolve(options.cwd);

      // Ensure target directory exists.
      if (!existsSync(cwd)) {
        logger.error(`The path ${cwd} does not exist. Please try again.`);
        process.exit(1);
      }

      const config = await getMultiverseUIConfig(cwd);
      if (config) {
        logger.info(
          `Your project already has a ${chalk.green('multiverse.config.json')} file. If you want to reinitialize, please delete it first, then run the init command again.`
        );
        return;
      } else {
        await runSetupProcess(cwd);
      }

      logger.info('');
      logger.info(
        `${chalk.green(
          'Success!'
        )} Project initialization completed. You may now add components.`
      );
      logger.info('');
    } catch (error) {
      if (typeof error === 'string') {
        logger.error(error);
        process.exit(1);
      }

      if (error instanceof Error) {
        logger.error(error.message);
        process.exit(1);
      }

      logger.error('Something went wrong. Please try again.');
      process.exit(1);
    }
  });

export default init;
